import styled from "styled-components";

export const BannerGridWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 100%;

  @media screen and (max-width: 991px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media screen and (max-width: 767px) {
    grid-template-columns: repeat(1, 1fr);
  }

  .swiper-button-prev {
    color: #3bb77e;
    left: 0px;
    ::after {
      font-size: 30px;
    }
  }

  .swiper-button-next {
    color: #3bb77e;
    right: 0px;
    ::after {
      font-size: 30px;
    }
  }

  .swiper-pagination-fraction {
    background-color: #000;
    width: fit-content;
    padding: 0px 10px;
    border-radius: 20px;
    left: auto;
    right: 15px;
    color: #fff;
    font-size: calc(10px + (14 - 10) * ((100vw - 320px) / (1920 - 320)));
  }
`;

export const BannerSection = styled.section`
  overflow: hidden;
  width: 100%;

  .pc_swiper {
    display: block;
  }

  .m_swiper {
    display: none;
    overflow: visible;
    margin: 0 auto;
    position: relative;
  }

  figure {
    margin: 0;
    padding: 0;
    width: 100%;
  }

  img {
    width: 100%;
    height: auto;
  }

  @media screen and (max-width: 767px) {
    padding: 0px;

    .pc_swiper {
      display: none;
    }

    .m_swiper {
      display: block;
    }
  }

  &.pc-only {
    display: block;

    @media (max-width: 767px) {
      display: none;
    }
  }
`;

export const TitleWrapper = styled.h4`
  font-weight: bold;
  line-height: 1.4;
  background-color: ${({ index }) =>
    index === 0 ? "#d8f5d1" : index === 1 ? "#cceeff" : "#fff8cc"};
`;

export const BannerBox = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 60px;

  @media screen and (max-width: 767px) {
    flex-direction: column;
    align-items: center;
    margin-bottom: 30px;
  }
`;

export const BannerHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  width: 70%;

  h4 {
    font-size: 24px;
    font-weight: bold;
    margin: 0;
  }

  @media screen and (max-width: 991px) and (min-width: 768px) {
    width: 100%;
  }

  @media screen and (max-width: 767px) {
    width: 100%;
    flex-direction: row;
    align-items: center;
  }
`;

export const CertificationImageRow = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 8px;
  margin-top: 10px;

  > a {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;

    img {
      width: 100%;
      max-width: 100%;
      height: auto;
      display: block;
      margin: 0 auto;
    }

    span {
      display: block;
      font-size: 16px;
      margin-top: 4px;
      color: #333;
    }
  }
`;
